import { PowerSyncDatabase } from "@powersync/web";
import { AppSchema } from "../powersync/schema.js";
/**
 * Opens the local SQLite replica (PowerSync Web SDK → wa-sqlite on OPFS, IndexedDB fallback).
 * Works inside Capacitor and Tauri webviews as well as browsers (ADR 001/003).
 */
export function openEctDatabase(opts = {}) {
    return new PowerSyncDatabase({
        schema: AppSchema,
        database: { dbFilename: opts.dbFilename ?? "ect.sqlite" },
        flags: { enableMultiTabs: false, disableSSRWarning: true },
    });
}
export async function connectEctDatabase(db, connector) {
    await db.init();
    await db.connect(connector);
}
/** Number of local writes not yet uploaded (drives the SyncPill count). */
export async function pendingUploads(db) {
    const rows = await db.getAll("select count(*) as n from ps_crud");
    return Number(rows[0]?.n ?? 0);
}
//# sourceMappingURL=database.js.map